export const collectionGradients = {
  gradientBlueEmerald:
    'bg-gradient-to-r from-contentBlue to-contentEmerald bg-clip-text text-transparent',
  gradientRedYellow:
    'bg-gradient-to-r from-contentRed to-contentYellow bg-clip-text text-transparent',
  gradientPurpleSky:
    'bg-gradient-to-r from-contentPurple to-contentSky bg-clip-text text-transparent',
  gradientFuchsiaRed:
    'bg-gradient-to-r from-contentFuchsia to-contentRed bg-clip-text text-transparent',
  gradientGreenCyan:
    'bg-gradient-to-r from-contentGreen to-contentCyan bg-clip-text text-transparent',
  gradientYellowGreen:
    'bg-gradient-to-r from-contentYellow to-contentGreen bg-clip-text text-transparent',
  gradientIndigoFuchsia:
    'bg-gradient-to-r from-contentIndigo to-contentFuchsia bg-clip-text text-transparent',
  gradientCyanIndigo:
    'bg-gradient-to-r from-contentCyan to-contentIndigo bg-clip-text text-transparent',
  gradientPinkViolet:
    'bg-gradient-to-r from-contentPink to-contentViolet bg-clip-text text-transparent',
  gradientEmeraldAmber:
    'bg-gradient-to-r from-contentEmerald to-contentAmber bg-clip-text text-transparent'
} as const

export type GradientName = keyof typeof collectionGradients
